import io from 'socket.io-client';
import axios from 'axios';
import constants from './constants';

const initiateSocketConnection = ({ uri, currentUser, onConnect }) => {
    try {
        console.log('Attempting socket connection to:', uri);

        const socketOptions = {
            transports: ['websocket'],
            forceNew: true,
            reconnection: true,
            reconnectionAttempts: 5,
            reconnectionDelay: 1000,
            timeout: 10000
        };

        const newSocket = io(uri, socketOptions);

        if (newSocket) {
            newSocket.auth = currentUser;

            // Add more detailed error handling
            newSocket.on('connect_error', (error) => {
                // console.error('Socket connection error:', error.message);
            });

            newSocket.on('connect_timeout', () => {
                // console.error('Socket connection timeout');
            });

            newSocket.on('disconnect', (reason) => {
                // console.log('Socket disconnected:', reason);
            });

            newSocket.on('connect', () => {
                // console.log('Socket connected successfully. Socket ID:', newSocket.id);
                if (onConnect) {
                    onConnect(true);
                }
            });

            return newSocket;
        }
    } catch (error) {
        // console.error('Socket initialization error:', error.message);
        return null;
    }
};

const getThread = async (selectedConsultant, cb) => {
    try {
        const { data: { success, message, data } } = await axios.post(`${constants.CHAT_SERVER_API}/chats/create-thread-admin`, {
            user: {
                _id: selectedConsultant._id,
                name: selectedConsultant.accountName,
                profileImage: selectedConsultant.profileImage
            },
            admin: {
                _id: '000000000000000000000000',
                name: 'Vedicmeet Admin',
                profileImage: 'https://vedicmeet.com/statics/vedic-meet_title-logo.webp'
            }
        });
        if (success) {
            cb(data);
            return data;
        }
        return null;
    } catch (error) {
        cb(null);
        return null;
    }
}


export { initiateSocketConnection, getThread };